<template>
  <div class="sui-checkbox" :class="{ 'sui-checkbox--disabled': disabled}">
    <label class="sui-checkbox__container">
      <div class="sui-checkbox__icon-container" :class="icon_container_classes">
        <Icon :name="checkbox_state"></Icon>
      </div>
      <div class="sui-checkbox__title-container font-body-m">
        <div class="sui-checkbox__title" v-html="label"></div>
        <div v-if="description" class="sui-checkbox__description"> {{ description }} </div>
      </div>
      <input 
        class="sui-checkbox__control"
        :name="name"
        :checked="modelValue"
        :indeterminate="indeterminate"
        type="checkbox"
        :disabled="disabled"
         @change="onChange"
      />
    </label>
  </div>
</template>

<!-- TODO: readonly -->

<script setup lang="ts">
  import { toRefs, computed } from 'vue'

  // Components
  import Icon from '../icon/Icon.vue'

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    hasErrors: {
      type: Boolean,
      default: false
    }
  })

  const { disabled, modelValue, description, label, name, hasErrors, indeterminate } = toRefs(props)

  const emit = defineEmits(['update:modelValue', 'change'])

const checkbox_state = computed(() => {
  if (indeterminate.value) return 'minus'
    return modelValue?.value ? `done` : ``
    
  })

  const icon_container_classes: { [key: string]: any } = computed(() => {
    return {
      'sui-checkbox__icon-container--checked': modelValue?.value,
      'sui-checkbox__icon-container--disabled': disabled.value,
      'sui-checkbox__icon-container--indeterminate': indeterminate.value && modelValue.value === null,
      'sui-checkbox__icon-container--has-errors': hasErrors.value
    }
  })

  function onChange(event: Event): void {
    emit('update:modelValue', (event.target as HTMLInputElement).checked)
  }

</script>

<style scoped lang="scss">
.sui-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  &--disabled {
    pointer-events: none;
  }

  &__container {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0px;
    gap: 8px;
    cursor: pointer;
  }

  &__control {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:indeterminate {
      .sui-checkbox__title-container {
        border-color: aqua;
      }
    }
  }

  &__label {
    height: 24px;
    width: 24px;
    background-color: var(--color-bg-primary);
    border-radius: var(--border-radius);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  &__icon-container {
    height: 24px;
    width: 24px;
    background-color: var(--color-bg-primary);
    border-radius: var(--border-radius);
    border: 1px var(--stroke-select) solid;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    cursor: pointer;
    flex-shrink: 0;

    &--checked, &--indeterminate {
      background-color: var(--color-button-default);
      border-color: var(--color-button-default);
      color: #FFF
    }

    &--has-errors {
      background-color: #fff;
      border-color: var(--color-button-default);
    }

    &--disabled {
      background-color: var(--color-button-disabled);
      color: var(--color-icon-secondary);
      border: 1px var(--color-button-disabled) solid;

      &:not(.sui-checkbox__icon-container--checked, .sui-checkbox__icon-container--indeterminate) {
        border: 1px var(--stroke-select) solid;
      }
    }
  }
  
  &__title {
    display: flex;
    // height: 100%;
    // align-items: center;
    flex: 1;
  }

  &__description {
    color: #9EA0B3;
  }

  &__icon {
    width: 100%;
    height: 100%;
    user-select: none;
  }
}
</style>
